const VIDEO_MIME_TYPE_BY_EXTENSION: Record<string, string> = {
  mp4: 'video/mp4',
  webm: 'video/webm',
  mov: 'video/quicktime',
  ogv: 'video/ogg',
}

/**
 * Derives a video MIME type from a media URL's file extension, since Prismic's generic
 * `Link to media` field can point to any file type an editor uploads (mp4, webm, ...).
 * A mismatched `type` on a `<source>` (e.g. a webm file declared as video/mp4) can make
 * stricter browsers such as Safari refuse to play it.
 */
export const getVideoMimeType = (url: string | null | undefined): string => {
  const extension = url?.split('?')[0]?.split('.').pop()?.toLowerCase()

  return (extension && VIDEO_MIME_TYPE_BY_EXTENSION[extension]) || 'video/mp4'
}
